import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const searchFieldStyle = css`
  margin-bottom: ${theme.spacing(1)};
`;

export const optionStyle = css`
  padding: ${theme.spacing(1, 0.5)};
  span {
    display: flex;
    gap: ${theme.spacing(1)};
  }
`;

export const radioStyle = css`
  border-bottom: 1px solid ${theme.colors.neutral20};
  overflow: visible;
`;

export const radioFieldStyle = css`
  margin-bottom: ${theme.spacing(0)};
  padding: ${theme.spacing(1, 0.5)};
`;

export const listboxStyle = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  height: 240px;
`;
export const buttonStyle = css`
  margin-top: ${theme.spacing(1)};
  width: 100%;
`;

export const selfUserContainer = css`
  display: flex;
  gap: ${theme.spacing(1)};
  align-items: center;
`;
